export const insights = [
  {
    slug: 'website-costs-toronto-professional-services',
    title: 'Website costs for a Toronto professional-service business',
    description: 'A practical breakdown of what changes the cost of a business website, what is usually included, and which ongoing costs belong in the plan.',
    published: 'September 29, 2026',
    publishedIso: '2026-09-29',
    readTime: '6 min read',
  },
];

export const getInsightBySlug = (slug) => insights.find((insight) => insight.slug === slug);
